import React from 'react';
import { Text } from '@etg/wings';
import { css } from '@eti/styles';
import { Price } from './CartComponents';

interface CartQpassProps {
  title: string;
  priceLabel: string;
}

const styles = css`
  display: grid;
  grid-template-columns: 1fr 1fr;

  .included {
    text-align: end;
  }
`;

const CartQpass = ({ title, priceLabel }: CartQpassProps) => {
  const testId = 'cart-qpass';
  return (
    <div className={styles} data-testid={`${testId}-container`}>
      <Text as="p" data-testid={`${testId}-header`} variant="16-bold">
        {title}
      </Text>
      <Price className="included" data-testid={`${testId}-included-text`} isDiscount>
        {priceLabel}
      </Price>
    </div>
  );
};

export default CartQpass;
